import {
  CheckNotes,
  InspectionCase,
  InspectionWaterSupplyDataCase,
  InspectionWaterSupplyDataCaseDto
} from '../../inspection-cases';

export class FireExtinguishingReservoirDto extends InspectionCase {
  reservoirVolume?: InspectionWaterSupplyDataCaseDto; // PoolingVolume
  reservoirMaterialType?: InspectionCase;
  vortexPlateDesign?: InspectionCase;
  ballcockDesign?: InspectionCase;
  overflowPipeDesign?: InspectionCase;
  drainingDesign?: InspectionCase;
}
export class FireExtinguishingReservoir extends FireExtinguishingReservoirDto {
  constructor(
    data: FireExtinguishingReservoirDto = {
      title: 'מאגר מים לכיבוי אש בהתאם לדרישות NFPA-22'
    }
  ) {
    super(data);
    this.reservoirVolume = new InspectionWaterSupplyDataCase({
      ...data.reservoirVolume,
      title: 'ציין את נפח מאגר המים'
    }); // m^3
    this.reservoirMaterialType = new InspectionCase({
      ...data.reservoirMaterialType,
      title: ' ציין את סוג החומר ממנו עשויי המאגר'
    });
    this.vortexPlateDesign = new InspectionCase({
      ...data.vortexPlateDesign,
      title: 'האם תוכננה פלטת וורטקס'
    });
    this.ballcockDesign = new InspectionCase({
      ...data.ballcockDesign,
      title: 'האם תכנן מגוף מילוי מאגר המים בהתאם לדרישות התקן'
    });
    this.overflowPipeDesign = new InspectionCase({
      ...data.overflowPipeDesign,
      title: 'האם תכנון צינור גלישה למאגר המים בהתאם לדרישות התקן'
    });
    this.drainingDesign = new InspectionCase({
      ...data.drainingDesign,
      title: 'האם תכנון צינור ריקון מאגר בהתאם לדרישות התקן'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.reservoirVolume.isApplicable || this.reservoirVolume.isPassed) &&
        (!this.reservoirMaterialType.isApplicable ||
          this.reservoirMaterialType.isPassed) &&
        (!this.vortexPlateDesign.isApplicable ||
          this.vortexPlateDesign.isPassed) &&
        (!this.ballcockDesign.isApplicable || this.ballcockDesign.isPassed) &&
        (!this.overflowPipeDesign.isApplicable ||
          this.overflowPipeDesign.isPassed) &&
        (!this.drainingDesign.isApplicable || this.drainingDesign.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.reservoirVolume.getNotes(),
      ...this.reservoirMaterialType.getNotes(),
      ...this.vortexPlateDesign.getNotes(),
      ...this.ballcockDesign.getNotes(),
      ...this.overflowPipeDesign.getNotes(),
      ...this.drainingDesign.getNotes()
    ];
  }
}
